import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {PropertyInitialResponseDto} from "../dto/property.initial.response.dto";

@Injectable({
    providedIn: 'root'
})
export class PropertyInitialSubject {
    private propertySubject = new BehaviorSubject<PropertyInitialResponseDto | null>(null);
    property$ = this.propertySubject.asObservable();

    /**
     * Actualiza la propiedad en el BehaviorSubject si es diferente a la actual.
     * @param propertyInitialDto Datos iniciales de la propiedad.
     */
    public updateProperty(propertyInitialDto: PropertyInitialResponseDto): void {
        const current = this.propertySubject.value;

        // Verifica si realmente cambió (puedes implementar un equals si necesitas comparar por valor)
        if (!this.isEqual(current, propertyInitialDto)) {
            this.propertySubject.next(propertyInitialDto);
            console.log('[PropertySubject] Emitted new property:', propertyInitialDto);
        } else {
            console.log('[PropertySubject] No changes in property. Skipped emission.');
        }
    }

    /**
     * Devuelve el valor actual almacenado de la propiedad.
     */
    public getCurrentProperty(): PropertyInitialResponseDto | null {
        return this.propertySubject.value;
    }

    /**
     * Compara dos DTOs de forma superficial.
     * Si necesitas una comparación profunda, usa lodash/isEqual o escribe una función recursiva.
     */
    private isEqual(a: PropertyInitialResponseDto | null, b: PropertyInitialResponseDto): boolean {
        if (!a) return false;
        return JSON.stringify(a) === JSON.stringify(b);
    }
    /**
     * Resetea el estado del BehaviorSubject a null.
     */
    public resetProperty(): void {
        this.propertySubject.next(null);
    }


}
